import * as React from "react";
const SvgFiRrAirplay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-airplay_svg__a)">
      <path
        fill="#062147"
        d="M14.497 13.169a3.249 3.249 0 0 0-4.999.007l-5.55 6.775a1.85 1.85 0 0 0-.243 1.981 1.85 1.85 0 0 0 1.687 1.067h13.215c.729 0 1.375-.409 1.687-1.066a1.85 1.85 0 0 0-.242-1.983zM5.674 21l5.366-6.55c.477-.572 1.45-.565 1.916-.007L18.327 21zM24 6v8a5 5 0 0 1-1.692 3.75.997.997 0 0 1-1.412-.089 1 1 0 0 1 .089-1.411A3 3 0 0 0 22.001 14V6c0-1.654-1.346-3-3-3H5C3.346 3 2 4.346 2 6v8a3 3 0 0 0 1.016 2.25 1 1 0 0 1-1.324 1.5A5 5 0 0 1-.001 14V6A5.007 5.007 0 0 1 5 1h14c2.757 0 5 2.243 5 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-airplay_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAirplay;
